import ActionTypes from '@ziynx/action-types';
import { getActionGroup } from '@ziynx/components/utilities';
import type { MongoIdType } from '@ziynx/flow-types/globals';

type GetTeamListResponse = {
  isLastPage: boolean,
  page: number,
  pageSize: number,
  total: number,
  results: Array<{
    _id: MongoIdType,
    email: string,
    firstName: string,
    lastName: string,
    role: 'owners' | 'managers' | 'admins',
    userStatus: 'PENDING' | 'EXPIRED' | 'CONFIRMED'
  }>,
};

type TeamAction = {
  type: string,
  response?: GetTeamListResponse,
  error?: any,
  memberId?: MongoIdType, // Team member id to be removed
}

const initialState = {};

export default function reduceTeams(state = initialState, action: TeamAction) {
  if (!action.type) {
    return state;
  }

  const actionGroup: string = getActionGroup(action?.type);

  switch (action.type) {
  case ActionTypes.team.get.START:
  case ActionTypes.team.removeUser.START:
  case ActionTypes.teamMember.removeInvite.START:
    return {
      ...state,
      ...{
        [actionGroup]: {
          ...state[actionGroup],
          fetching: true,
          success: false,
          error: null,
        },
      },
    };
  case ActionTypes.team.get.SUCCESS:
    return {
      ...state,
      [actionGroup]: {
        ...(state[actionGroup] ?? {}),
        ...(action?.response ?? {}),
        results:
          action?.response?.page > 0
            ? (state[actionGroup] || {})?.results.concat(action?.response?.results ?? [])
            : action?.response?.results,
        fetching: false,
        success: true,
        error: null,
      },
    };
  case ActionTypes.team.removeUser.SUCCESS:
  case ActionTypes.teamMember.removeInvite.SUCCESS:
    return {
      ...state,
      GET_TEAM_LIST_API: {
        ...(state?.GET_TEAM_LIST_API || {}),
        results: state?.GET_TEAM_LIST_API?.results.filter(
          (member) => member?._id !== action?.memberId,
        ),
      },
      [actionGroup]: {
        fetching: false,
        success: true,
        error: null,
      },
    };
  case ActionTypes.teamMember.resendInvite.SUCCESS:
    return {
      ...state,
      GET_TEAM_LIST_API: {
        ...(state?.GET_TEAM_LIST_API || {}),
        results: state?.GET_TEAM_LIST_API?.results.map(
          (member) => {
            if (member?._id !== action?.memberId) return member;
            return { ...member, userStatus: action?.userStatus };
          },
        ),
      },
      [actionGroup]: {
        fetching: false,
        success: true,
        error: null,
      },
    };
  case ActionTypes.team.get.ERROR:
  case ActionTypes.team.removeUser.ERROR:
  case ActionTypes.teamMember.removeInvite.ERROR:
    return {
      ...state,
      ...{
        [actionGroup]: {
          ...(state[actionGroup] || {}),
          success: false,
          fetching: false,
          error: action?.error,
        },
      },
    };
      // no default
  }
  return state;
}
